const TYPES = ({
  generateExcel: 'GENERATE_CSV_AMENDMENT',

  // dash
  summaryData: 'SUMMARY_AMENDMENT_DATA',
  summaryRequestError: 'SUMMARY_AMENDMENT_ERROR',

  // list
  loadingFormSearch: 'LOADING_SEARCH_AMENDMENT_FORM_TOGGLE',
  searchSuccess: 'SEARCH_AMENDMENT_SUCCESS',
  searchError: 'SEARCH_AMENDMENT_LIST_ERROR',

  // form create
  updateItemListingManagerSuccess: 'MANAGER_AMENDMENT_SUCCESS_UPDATE_LISTING',

  // form search
  changeFormSearchField: 'CHANGE_SEARCH_AMENDMENT_FORM_FIELD',
  setDefaultPage: 'SET_SEARCH_AMENDMENT_DEFAULT_PAGE',
  clearFormSearchFields: 'CLEAR_FIELDS_AMENDMENT_FORM',
  paginationFormSearch: 'SEARCH_AMENDMENT_PAGINATION',
});

export default TYPES;
